var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "inputAuthCodeSection", class: { isPc: !_vm.isSp } },
    [
      _c("TitleText", { attrs: { text: "認証コード入力" } }),
      _vm._v(" "),
      _c("p", { staticClass: "mailAddress" }, [
        _vm._v(
          _vm._s(_vm.mailAddress.emailAccount) +
            "@" +
            _vm._s(_vm.mailAddress.emailDomain)
        ),
      ]),
      _vm._v(" "),
      _c("TextGeneral", { staticClass: "text" }, [
        _vm._v("\n    上記メールアドレス宛にメールを送信しました。"),
        _c("br"),
        _vm._v("メールに記載の認証コードを入力してください。\n  "),
      ]),
      _vm._v(" "),
      _c("InputAreaWithValidation", {
        staticClass: "inputAuthCode",
        attrs: {
          "area-label": "認証コード",
          "input-type": "text",
          placeholder: "例）ng6xp3",
          "error-from-outer": _vm.authCodeValidationError,
        },
        on: { watchValidation: _vm.watchAuthCodeValidation },
        model: {
          value: _vm.inputAuthCode,
          callback: function ($$v) {
            _vm.inputAuthCode = $$v
          },
          expression: "inputAuthCode",
        },
      }),
      _vm._v(" "),
      _c("ServerErrorArea", {
        staticClass: "serverErrorArea",
        attrs: {
          "error-type": _vm.errorType,
          "server-error-list": _vm.serverErrorList,
        },
      }),
      _vm._v(" "),
      _c("ButtonTypeCustom", {
        staticClass: "authButton",
        class: { isDisabled: !_vm.canSendRequest },
        attrs: {
          "button-type": "button",
          "button-text": "認証する",
          "button-color": "colorPrimary",
          "button-size": "sizeLarge",
        },
        on: { "button-clicked": _vm.sendAuth },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "note" }, [
        _vm._v(
          "\n    ※ドメイン指定、迷惑メール設定によりメールが届かない場合があります。＠shingakunet.comからのメールが受信できるよう設定を変更してください。\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rightItems" }, [
        _c(
          "p",
          { staticClass: "resendMail", class: { isPc: !_vm.isSp } },
          [
            _c("TextLink", {
              attrs: {
                "arrow-type": "rightArrowRight",
                "link-text": "メールを再送信する",
              },
              on: { onClick: _vm.onClickResendMail },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          [
            _c("TextLink", {
              attrs: {
                "arrow-type": "rightArrowRight",
                "link-text": "メールアドレスを修正する",
              },
              on: { onClick: _vm.fixMailAddress },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("Confirm", {
        attrs: {
          "is-open": _vm.isResendConfirmOpen,
          text: "メールを再送信します。\nよろしいですか？",
          "positive-custom-text": "送信する",
          "font-bold": "",
          persistent: "",
        },
        on: { "close-dialog": _vm.closeResendDialog },
      }),
      _vm._v(" "),
      _c("Alert", {
        attrs: {
          "is-open": _vm.isResendDoneDialogOpen,
          text: "メールを再送信しました。",
          persistent: "",
        },
        on: { "close-dialog": _vm.closeResendAfterDialogs },
      }),
      _vm._v(" "),
      _c("Error", {
        attrs: {
          "is-open": _vm.isResendErrorDialogOpen,
          title: "メールの再送信に失敗しました。",
          "detail-error-list": _vm.resendErrorList,
          persistent: "",
          "button-custom-text": "閉じる",
        },
        on: { "click-dialog-button": _vm.closeResendAfterDialogs },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }